import { rj } from 'react-rocketjump'
import { ajax } from 'rxjs/ajax'

export const PianiTariffariState = rj({
  name: 'PianiTariffari',
  effect: () => ajax.getJSON(`/api/piani-tariffari`),
})
